import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import {
    CellStyleModule,
    ClientSideRowModelModule,
    ClientSideRowModelApiModule,
    ClipboardModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ColumnMenuModule,
    ColumnsToolPanelModule,
    ContextMenuModule,
    CsvExportModule,
    CustomFilterModule,
    DateFilterModule,
    EventApiModule,
    ExcelExportModule,
    GridStateModule,
    GroupFilterModule,
    ModuleRegistry,
    MultiFilterModule,
    NewFiltersToolPanelModule,
    NumberFilterModule,
    PinnedRowModule,
    PivotModule,
    QuickFilterModule,
    RowGroupingModule,
    RowGroupingPanelModule,
    RowSelectionModule,
    SetFilterModule,
    SideBarModule,
    TextFilterModule,
    ValidationModule,
    LicenseManager
} from 'ag-grid-enterprise';
import { Environment } from './app/environment.interface';

const config = (globalThis as any).__config as Environment;

if (['localDevelopment', 'development'].includes(config.env)) {
    ModuleRegistry.registerModules([ValidationModule]);
}

/** AG Grid **
 * AG Grid is configured to use individual feature modules instead of AllEnterpriseModule
 * to reduce bundle size. When adding new grid features, ensure the appropriate modules
 * are imported. See: https://www.ag-grid.com/angular-data-grid/modules/
 * ModuleRegistry.registerModules([AllEnterpriseModule]);
 */
ModuleRegistry.registerModules([
    CellStyleModule,
    ClientSideRowModelModule,
    ClientSideRowModelApiModule,
    ClipboardModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ColumnMenuModule,
    ColumnsToolPanelModule,
    ContextMenuModule,
    CsvExportModule,
    CustomFilterModule,
    DateFilterModule,
    EventApiModule,
    ExcelExportModule,
    GridStateModule,
    GroupFilterModule,
    MultiFilterModule,
    NewFiltersToolPanelModule,
    NumberFilterModule,
    PinnedRowModule,
    PivotModule,
    QuickFilterModule,
    RowGroupingModule,
    RowGroupingPanelModule,
    RowSelectionModule,
    SetFilterModule,
    SideBarModule,
    TextFilterModule,
]);

LicenseManager.setLicenseKey('Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-115830}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{ANGUS_ENERGY}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Angus.application}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Angus.application}_need_to_be_licensed___{Angus.application}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{15_December_2026}____[v3]_[0102]_MTc5NzI5MjgwMDAwMA==5e3f13cc66c3f584fdc8e1f44b89ef13');

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
